module.exports = __webpack_public_path__ + "static/media/coins.2cb63405.png";